var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 154,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-220 -98)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M310.25 116.531C310.25 123.573 304.542 129.281 297.5 129.281 290.458 129.281 284.75 123.573 284.75 116.531 284.75 109.49 290.458 103.781 297.5 103.781 304.542 103.781 310.25 109.49 310.25 116.531Z",
    fill: "#FF0000",
    fillRule: "nonzero",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.244 182.194 323.319 144.262C323 142.988 322.362 141.712 321.406 140.756 317.581 137.569 313.119 135.337 308.019 133.744 304.513 133.106 301.006 132.469 297.5 132.469 293.994 132.469 290.487 133.106 286.981 134.062 281.881 135.337 277.419 137.887 273.594 141.075 272.638 142.031 272 143.306 271.681 144.581L262.756 182.512C262.756 182.831 262.438 183.469 262.438 184.106 262.438 187.613 265.306 190.481 268.812 190.481 271.681 190.481 274.231 188.25 274.869 185.7L281.562 157.969 281.562 247.219 294.312 247.219 294.312 189.844 300.688 189.844 300.688 247.219 313.438 247.219 313.438 157.65 320.131 185.381C320.769 187.931 323.319 190.163 326.188 190.163 329.694 190.163 332.562 187.294 332.562 183.788 332.562 183.15 332.244 182.512 332.244 182.194Z",
    fill: "#FF0000",
    fillRule: "nonzero",
    fillOpacity: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson1);
export default __webpack_public_path__ + "static/media/person1.d6adc2463167b620c9de0198ebb62ba3.svg";
export { ForwardRef as ReactComponent };